// Fecha LOCAL yyyy-mm-dd. OJO: toISOString() es UTC — en Ecuador (UTC-5), después
// de las 19:00 devuelve la fecha de MAÑANA: filtros "hoy", defaults de formularios
// y nombres de archivo salían con la fecha corrida en la noche.
export const fechaLocal = (d: Date = new Date()): string =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
